import { memo } from "react";
import { Header } from "@tanstack/react-table";
import { Filter as DefaultFilter } from "./Filter";
import { hasCustomFilterComponent } from "@/lib/filters";

interface DataTableHeaderFilterProps<TData> {
  header: Header<TData, unknown>;
}

const DataTableHeaderFilterComponent = <TData extends { id: string }>({
  header,
}: DataTableHeaderFilterProps<TData>) => {
  if (!header.column.getCanFilter()) {
    return null;
  }

  const { meta } = header.column.columnDef;

  if (hasCustomFilterComponent(meta?.filter)) {
    const { component: FilterComponent, props } = meta.filter;
    return <FilterComponent {...(props ?? {})} columnId={header.id} />;
  }

  return <DefaultFilter columnId={header.id} meta={meta} />;
};

DataTableHeaderFilterComponent.displayName = "DataTableHeaderFilter";

const DataTableHeaderFilter = memo(
  DataTableHeaderFilterComponent,
) as typeof DataTableHeaderFilterComponent;

export default DataTableHeaderFilter;
